export const subscribe = async (data) => {
    const proxy = "https://my-mailchimp-worker.dev-212.workers.dev/subscribe";

    const response = await fetch(proxy, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error(await response.text());
    }
}